import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tj32",
  "use": "icon-tj32-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tj32\"><path d=\"M447.8 132.6v379.2c0 35.3 28.7 64 64 64H891c-4.9 29.4-13.2 58-24.9 85.6-19.4 45.8-47.1 86.9-82.4 122.2-35.3 35.3-76.5 63.1-122.2 82.4-47.4 20-97.7 30.2-149.6 30.2S409.6 886 362.3 866c-45.8-19.4-86.9-47.1-122.2-82.4-35.3-35.3-63.1-76.5-82.4-122.2-20-47.4-30.2-97.7-30.2-149.6s10.2-102.3 30.2-149.6c19.4-45.8 47.1-86.9 82.4-122.2 35.3-35.3 76.5-63.1 122.2-82.4 27.5-11.8 56.2-20.1 85.5-25m64-69.3c-247.7 0-448.5 200.8-448.5 448.5s200.8 448.5 448.5 448.5 448.5-200.8 448.5-448.5H511.8V63.3z\" p-id=\"17560\" /><path d=\"M608.1 191.8c-17.7 0-32 14.3-32 32v224.4h64V223.8c0-17.7-14.3-32-32-32z m128-63.8c-17.7 0-32 14.3-32 32v288.4h64V160c0-17.7-14.3-32-32-32z m127.7-63.8c-17.7 0-32 14.3-32 32v352.2h64V96.2c0-17.7-14.4-32-32-32z\" p-id=\"17561\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-tj32.svg
// module id = 7uqU
// module chunks = 177